package com.havn.app.ui.theme

enum class HavnThemeType(
    val storageKey: String,
    val displayName: String,
    val description: String
) {
    OBSIDIAN_GOLD(
        storageKey = "obsidian_gold",
        displayName = "Obsidian Gold",
        description = "Luxury black, graphite, and warm gold."
    ),
    MIDNIGHT_SAPPHIRE(
        storageKey = "midnight_sapphire",
        displayName = "Midnight Sapphire",
        description = "Deep navy, sapphire blue, and silver accents."
    ),
    EMERALD_ESTATE(
        storageKey = "emerald_estate",
        displayName = "Emerald Estate",
        description = "Dark emerald, charcoal, and champagne gold."
    ),
    PLATINUM_STONE(
        storageKey = "platinum_stone",
        displayName = "Platinum Stone",
        description = "Stone gray, platinum, and soft white."
    ),
    BORDEAUX_NOIR(
        storageKey = "bordeaux_noir",
        displayName = "Bordeaux Noir",
        description = "Dark wine, graphite, and copper accents."
    );

    companion object {
        fun fromStorageKey(value: String?): HavnThemeType =
            entries.firstOrNull { it.storageKey == value } ?: OBSIDIAN_GOLD
    }
}
